import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\MedicalCode\MedicalCodeSearchController::__invoke
* @see app/Http/Controllers/MedicalCode/MedicalCodeSearchController.php:14
* @route '/api/medical-codes/search'
*/
export const search = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: search.url(options),
    method: 'get',
})

search.definition = {
    methods: ["get","head"],
    url: '/api/medical-codes/search',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\MedicalCode\MedicalCodeSearchController::__invoke
* @see app/Http/Controllers/MedicalCode/MedicalCodeSearchController.php:14
* @route '/api/medical-codes/search'
*/
search.url = (options?: RouteQueryOptions) => {
    return search.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\MedicalCode\MedicalCodeSearchController::__invoke
* @see app/Http/Controllers/MedicalCode/MedicalCodeSearchController.php:14
* @route '/api/medical-codes/search'
*/
search.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: search.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\MedicalCode\MedicalCodeSearchController::__invoke
* @see app/Http/Controllers/MedicalCode/MedicalCodeSearchController.php:14
* @route '/api/medical-codes/search'
*/
search.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: search.url(options),
    method: 'head',
})

const medicalCodes = {
    search: Object.assign(search, search),
}

export default medicalCodes